import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { REPLACE_DISH_TYPE_MUTATION } from '../graphql/mutations'
import { REPLACE_DISH_TYPE } from '../redux/action-types'

const useReplaceDishTypeMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.dishTypes.dishTypes)

  const mutate = useCallback(
    async ({ idToReplace, replacementId }) => {
      await apolloService.mutate(
        REPLACE_DISH_TYPE_MUTATION,
        {
          idToReplace,
          replacementId,
        },
        dispatch,
        REPLACE_DISH_TYPE,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useReplaceDishTypeMutation
